import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Contact.css";
import { toast } from "react-toastify";

const Contact = () => {
  const formRef = useRef();

  const [formData, setFormData] = useState({
    from_name: "",
    reply_to: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    const { from_name, reply_to, message } = formData;

    if (!from_name || !reply_to || !message) {
      toast.error("Please fill in all the fields.");
      return;
    }

    setLoading(true);

    try {
      let response = await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
      if (!response.text === "OK") {
        toast.error("Failed to send the message. Please try again later.");
        setLoading(false);
        return;
      }
      toast.success("Message sent successfully!");
      setLoading(false);
      setSuccess(true);
      setFormData({
        from_name: "",
        reply_to: "",
        message: "",
      });
    } catch (error) {
      toast.error("Something went wrong. Please try again later.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container style={{ paddingTop: "50px" }}>
      <Row>
        <Col md={6} className="c-left">
          <h1>Get in Touch</h1>
          <h1 className="yellow">Contact me</h1>
        </Col>

        <Col md={6} className="c-right">
          <form ref={formRef} onSubmit={sendEmail}>
            <input
              type="text"
              name="from_name"
              className="user"
              placeholder="Name"
              value={formData.from_name}
              required
              onChange={handleChange}
            />

            <input
              type="email"
              name="reply_to"
              className="user"
              placeholder="Email"
              value={formData.reply_to}
              required
              onChange={handleChange}
            />

            <textarea
              name="message"
              className="user"
              placeholder="Message"
              value={formData.message}
              required
              onChange={handleChange}
            />

            <Button
              type="submit"
              className="button"
              disabled={loading || success}
            >
              {loading ? "Sending..." : "Send"}
            </Button>

            {success && (
              <span className="done">
                Thanks for contacting me! I have received your message and will
                get back to you soon. You can also reach me on LinkedIn.
              </span>
            )}
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
